import {
  HideSource,
  MoreVert,
  PersonRemove,
  VisibilityOff,
  SettingsBackupRestore,
  Edit,
} from "@mui/icons-material"
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material"
import React, { FC, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IChannel } from "../../interface/interface"
import { useUpdateChannelMutation } from "../../services/channels/channelsApi"
import { EditChannelForm } from "./editChannelForm"

interface IChannelCardProps extends IChannel {}

const ChannelCard: FC<IChannelCardProps> = (props) => {
  const navigate = useNavigate()
  const [updateChannel, { isLoading }] = useUpdateChannelMutation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const setHidden = (hidden: boolean) => {
    updateChannel({
      pathParams: { id: props.id },
      body: { is_hidden: hidden },
    })
  }

  const handleEditClick = () => {
    setEditDialogOpen(true)
    handleClose()
  }

  const handleEditClose = () => {
    setEditDialogOpen(false)
  }

  return (
    <>
      <Card>
        <CardHeader
          title={props.custom_name || props.title}
          subheader={
            <>
              {props.custom_name && (
                <>
                  {props.title}
                  <br />
                </>
              )}
              id: {props.id}{" "}
              {props.is_hidden && (
                <VisibilityOff sx={{ verticalAlign: "text-bottom" }} />
              )}
              {["kicked", "left", "restricted"].includes(props.status) && (
                <PersonRemove sx={{ verticalAlign: "text-bottom" }} />
              )}
            </>
          }
          action={
            <IconButton
              id="menu-button"
              aria-label="settings"
              onClick={handleClick}
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <MoreVert />
            </IconButton>
          }
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleEditClick}>
            <Edit /> &nbsp;Редактировать
          </MenuItem>
          <MenuItem
            disabled={isLoading}
            onClick={() => setHidden(!props.is_hidden)}
          >
            {props.is_hidden ? (
              <>
                <SettingsBackupRestore /> &nbsp;Отобразить
              </>
            ) : (
              <>
                <HideSource />
                &nbsp;Скрыть
              </>
            )}
            &nbsp;
            {isLoading && <CircularProgress size="1.5rem" color="primary" />}
          </MenuItem>
        </Menu>
        {/* <CardMedia
                component="img"
                alt="green iguana"
                height="140"
                image="/static/images/cards/contemplative-reptile.jpg"
            /> */}
        <CardContent>
          {props.comment && (
            <Typography variant="body2" color="text.secondary">
              {props.comment}
            </Typography>
          )}
        </CardContent>
        <CardActions>
          {/* <Link href={`${props.id}`} variant='button'>Подробнее</Link> */}
          <Button
            onClick={() =>
              navigate(`${props.id}`, {
                state: {
                  from: window.location.pathname,
                  title: "К списку каналов",
                },
              })
            }
          >
            Открыть размещения
          </Button>
        </CardActions>
      </Card>

      <Dialog
        open={editDialogOpen}
        onClose={handleEditClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Редактировать канал</DialogTitle>
        <DialogContent>
          <EditChannelForm
            channelId={props.id}
            initialValues={{
              is_hidden: props.is_hidden,
              custom_name: props.custom_name,
              comment: props.comment,
            }}
            onSuccess={handleEditClose}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ChannelCard
